import axios from 'axios'

/**
 * initial state
 */
const state = () => ({
  business_type: localStorage.getItem('business_type') || '',
  building_type: localStorage.getItem('building_type') || '',
  business_details: localStorage.getItem('business_details') || '',
  mall_id: localStorage.getItem('mall_id') || '',
  mall_name: localStorage.getItem('mall_name') || '',
  currentCustomerId: localStorage.getItem('customerId') || '',
  currentCompanyId: localStorage.getItem('companyId') || '',
  storeBlacklist: JSON.parse(localStorage.getItem('storeBlacklist')) || null,
})

/**
 * getters
 */
const getters = {
  /**
   * Get business_type
   * @returns business_type
   */
  getBusinessType(state) {
    if (state.business_type) {
      return JSON.parse(state.business_type)
    } else return ''
  },

  /**
   * Get building_type
   * @returns build_type
   */
  getBuildingType(state) {
    return state.building_type
  },

  /**
   * Get business_details
   * @returns business_details
   */
  getBusinessDetails(state) {
    return state.business_details
  },

  /**
   * Get mall_id
   * @returns mall_id
   */
  getMallId(state) {
    return state.mall_id
  },

  /**
   * Get mall_name
   * @returns mall_name
   */
  getMallName(state) {
    return state.mall_name
  },

  /**
   * Get current customer and company information
   * @returns current customer and company information
   */
  getCurrentInfo(state) {
    return {
      customerId: state.currentCustomerId,
      companyId: state.currentCompanyId,
    }
  },

  /**
   * Get cached core package type list from localStorage
   * @returns cached core package type list
   */
  getCachedCorePackageTypeList() {
    try {
      const cachedData = localStorage.getItem('corePackageTypeList')
      if (cachedData) {
        return JSON.parse(cachedData)
      }
      return null
    } catch (error) {
      console.error('Error reading from localStorage:', error)
      return null
    }
  },

  getStoreBlacklist(state) {
    return state.storeBlacklist
  },
}

/**
 * mutations
 */
const mutations = {
  /**
   * Set business type
   * @param {*} state
   * @param {*} data
   */
  setBusinessType(state, data) {
    state.business_type = data
  },

  /**
   * Set building type
   * @param {*} state
   * @param {*} data
   */
  setBuildingType(state, data) {
    state.building_type = data
  },

  /**
   * Set business details
   * @param {*} state
   * @param {*} data
   */
  setBusinessDetails(state, data) {
    state.business_details = data
  },

  /**
   * Set mall information
   * @param { mall_id, mall_name} data
   */
  setMallInfo(state, data) {
    state.mall_id = data.mallId
    state.mall_name = data.mallName
  },

  /**
   * Set mallName information
   * @param { mall_name} data
   */
  setMallName(state, data) {
    state.mall_name = data.mallName
  },

  /**
   * Clear Building information
   */
  clearCurrentBuildingInfo(state) {
    state.business_type = ''
    state.building_type = ''
    state.business_details = ''
    state.mall_id = ''
    state.mall_name = ''
  },

  /**
   * Set current customer and company information
   * @param {*} state
   * @param {*} data
   */
  setCurrentInfo(state, data) {
    state.currentCustomerId = data.customerId
    state.currentCompanyId = data.companyId
  },

  setBlacklist(state, data) {
    state.storeBlacklist = data
  },
}

/**
 * actions
 */
const actions = {
  /**
   * Clear CurrentBuilding information
   */
  clearBuildingInfo(context) {
    console.log('clear BuildingInfo')
    context.commit('clearCurrentBuildingInfo')
    localStorage.removeItem('business_type')
    localStorage.removeItem('building_type')
    localStorage.removeItem('business_details')
    localStorage.removeItem('mall_id')
    localStorage.removeItem('mall_name')
    localStorage.removeItem('store_blacklist')
  },

  /**
   * Select business type
   * @param business_type
   */
  selectBusinessType(context, credentials) {
    console.log(credentials)
    localStorage.setItem('business_type', JSON.stringify(credentials.business_type)) // Set value to local storage
    context.commit('setBusinessType', JSON.stringify(credentials.business_type))
  },

  /**
   * Select business type
   * @param building_type
   */
  selectBuildingType(context, credentials) {
    localStorage.setItem('building_type', credentials.building_type) // Set value to local storage
    context.commit('setBuildingType', credentials.building_type)
  },

  /**
   * Input business details
   * @param {*} context
   * @param {*} credentials
   * @returns
   */
  inputBusinessDetails(context, credentials) {
    localStorage.setItem('business_details', credentials.businessDetails)
    context.commit('setBusinessDetails', credentials.businessDetails)
  },

  /**
   * Select mall
   * @param mall_id
   */
  selectMall(context, credentials) {
    localStorage.setItem('mall_id', credentials.mallId)
    localStorage.setItem('mall_name', credentials.mallName)
    context.commit('setMallInfo', credentials)
  },

  addMallOther(context, credentials) {
    localStorage.setItem('mall_name', credentials.mallName)
    context.commit('setMallName', credentials)
  },

  /**
   * Get business type list
   * @return List of business type
   */
  getBusinessTypeList() {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_QUICKQUOTE_SME_BUSINESS_TYPE + '?search=all')
        .then((response) => {
          console.log('API Business_type', response)
          if (response.data.isSuccess) {
            // success
            resolve(response.data.data)
          } else {
            // !success
            console.error(response.data)
            reject(response.data.message)
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Get building type list
   * @return List of build type
   */
  getBuildingTypeList() {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_QUICKQUOTE_SME_BUILDING_TYPE)
        .then((response) => {
          console.log('API Building_type', response)
          if (response.data.isSuccess) {
            // success
            resolve(response.data.data)
          } else {
            // !success
            console.error(response.data)
            reject(response.data.message)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    })
  },

  /**
   * Get Store Lists
   * @param {*} context
   * @param {*} credentials
   * @returns
   */
  async getStoreLists(context) {
    try {
      const res = await axios.post(process.env.VUE_APP_STORE_LISTS, {
        page: 1,
        limit: 191,
        search: '',
        order: 'createdAt',
        sort: 'DESC',
      })
      console.log('API Post store lists ::', res)
      if (res.status === 200 && res.data.isSuccess) {
        const lists = await res.data.data.items
        const Lists = await lists.filter((x) => x.active === true)
        const blackLists = await lists.filter((x) => x.active === false)

        context.commit('setBlacklist', blackLists)
        localStorage.setItem('store_blacklist', JSON.stringify(blackLists))

        return Lists
      }
    } catch (err) {
      console.error(err)
      return []
    }
  },

  /**
   * Creat Quotation
   */
  createQuotation(context, credentials) {
    console.log('params', credentials)
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_QUICKQUOTE_SME_CREATE_QUOTATION, credentials)
        .then((response) => {
          console.log('API create quotation ::', response)
          if (response.data.isSuccess) {
            resolve(response)
          } else {
            if (
              response.data.code === 1001 &&
              response.data.message === 'protection_start_date not before current date'
            ) {
              resolve(response)
            } else reject(response.data.message)
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Get core package type list
   * @return List of core package types
   */
  getCorePackageTypeList() {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_QUICKQUOTE_CORE_PACKAGE_TYPE)
        .then((response) => {
          console.log('API Core Package Type', response)
          if (response.data.isSuccess) {
            // Save to localStorage
            localStorage.setItem('corePackageTypeList', JSON.stringify(response.data.data))
            resolve(response.data.data)
          } else {
            console.error(response.data)
            reject(response.data.message)
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Get cached core package type list from localStorage
   * @return List of core package types from localStorage
   */
  getCachedCorePackageTypeList() {
    try {
      const cachedData = localStorage.getItem('corePackageTypeList')
      if (cachedData) {
        return JSON.parse(cachedData)
      }
      return null
    } catch (error) {
      console.error('Error reading from localStorage:', error)
      return null
    }
  },

  /**
   * Get core status list
   * @return List of core statuses
   */
  getCoreStatusList() {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_QUICKQUOTE_CORE_STATUS)
        .then((response) => {
          console.log('API Core Status', response)
          if (response.data.isSuccess) {
            resolve(response.data.data)
          } else {
            console.error(response.data)
            reject(response.data.message)
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * List Quotation
   */
  listQuotation(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API list quotation params ::', credentials)
      axios
        .post(process.env.VUE_APP_QUICKQUOTE_SME_LIST_QUOTATION, credentials)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  /**
   * Create Assured
   */
  createAssured(context, credentials) {
    console.log('createAssured params ::', credentials)

    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_QUICKQUOTE_SME_CREATE_ASSURED, credentials)
        .then((response) => {
          console.log('API create assured ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              // isSuccess
              resolve(response.data.data)
            } else {
              // !isSuccess
              reject(response.data.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * View Quotation
   * @param smeFireInsuranceId
   * @return {array}
   */
  viewQuotation(context, credentials) {
    // console.log("params ::", credentials)
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_QUICKQUOTE_SME_QUOTATION_DETAIL + '/' + credentials.smeFireInsuranceId)
        .then((response) => {
          console.log('API view quotaion ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              // isSuccess
              resolve(response.data.data)
            } else {
              // !isSuccess
              reject(response.data.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * View customer detail
   * @param smeFireInsuranceId
   * @return {array}
   */
  viewCustomerDetail(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_QUICKQUOTE_SME_CUSTOMER_DETAIL + '/' + credentials.smeFireInsuranceId)
        .then((response) => {
          console.log('API view customer detail ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              // isSuccess
              resolve(response.data.data)
            } else {
              // !isSuccess
              reject(response.data.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Set current information
   */
  setCurrentInfo(context, credentials) {
    console.log('set current info :', credentials)
    localStorage.setItem('customerId', credentials.customerId)
    localStorage.setItem('companyId', credentials.companyId)
    context.commit('setCurrentInfo', credentials)
  },

  /**
   * Create Referer
   * @param {Object} credentials - The referer data
   * @param {number} credentials.calculated_id - Calculated ID
   * @param {string} credentials.seller_code - Seller code
   * @param {string} credentials.seller_name - Seller name
   * @param {boolean} credentials.isRefer - Whether this is a refer
   * @param {string} [credentials.refer_code] - Refer code
   * @param {string} [credentials.refer_name] - Refer name
   * @returns {Promise}
   */
  createReferer(context, credentials) {
    console.log('createReferer params ::', credentials)

    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_QUICKQUOTE_SME_CREATE_REFERER, credentials)
        .then((response) => {
          console.log('API create referer ::', response)
          if (response.status === 200) {
            if (response.data.isSuccess) {
              resolve(response.data)
            } else {
              reject(response.data.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Confirm Payment
   * @param {Object} credentials - The payment confirmation data
   * @param {string} credentials.idHash - Quotation ID hash
   * @param {string} credentials.invoiceNo - Invoice number
   * @param {string} credentials.paymentDate - Payment date (YYYY-MM-DD)
   * @returns {Promise}
   */
  confirmPayment(context, credentials) {
    console.log('confirmPayment params ::', credentials)

    const url = process.env.VUE_APP_QUICKQUOTE_SME_CONFIRM_PAYMENT.replace(':id_hash', credentials.idHash)
    const params = {
      invoice_no: credentials.invoiceNo,
      payment_date: credentials.paymentDate,
    }

    return new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then((response) => {
          console.log('API confirm payment ::', response)
          if (response.status === 200) {
            if (response.data.isSuccess) {
              resolve(response.data)
            } else {
              reject(response.data.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Upload Cer VAT document
   * @param {Object} credentials
   * @param {File} credentials.file - The file to upload
   * @returns {Promise}
   */
  uploadCerVat(context, credentials) {
    console.log('uploadCerVat params ::', credentials)

    const formData = new FormData()
    formData.append('cer_vat', credentials.file)

    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_QUICKQUOTE_SME_UPLOAD_CER_VAT, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          console.log('API upload cer vat ::', response)
          if (response.status === 200) {
            if (response.data.isSuccess) {
              resolve(response.data)
            } else {
              reject(response.data.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Convert Policy
   * @param {Object} credentials - The policy conversion data
   * @param {string} credentials.idHash - Quotation ID hash
   * @param {string} credentials.block - Block
   * @param {string} credentials.policyNo - Policy number
   * @param {number} credentials.coveragePeriod - Coverage period
   * @param {string} credentials.protectionStartDate - Protection start date (YYYY-MM-DD)
   * @param {string} credentials.protectionEndDate - Protection end date (YYYY-MM-DD)
   * @returns {Promise}
   */
  convertPolicy(context, credentials) {
    console.log('convertPolicy params ::', credentials)
    let insuranceBroker = ''

    // helper funciton
    if (credentials.non_life_insurance_broker) {
      insuranceBroker =
        credentials.non_life_insurance_broker == 'bank'
          ? 'นายหน้าประกันวินาศภัย ธนาคารทหารไทยธนชาต จำกัด (มหาชน) ใบอนุญาตเลขที่ ว00008/2546 (ช่องทางธนาคาร)'
          : 'นายหน้าประกันวินาศภัย บริษัท ทหารไทยธนชาต โบรคเกอร์ จำกัด ใบอนุญาตเลขที่ ว00020/2549 (ช่องทางโบรคเกอร์)'
    }

    const url = process.env.VUE_APP_QUICKQUOTE_SME_CONVERT_POLICY.replace(':id_hash', credentials.idHash)
    const params = {
      block: credentials.block,
      policy_no: credentials.policyNo,
      coverage_period: credentials.coveragePeriod,
      protection_start_date: credentials.protectionStartDate,
      protection_end_date: credentials.protectionEndDate,
      non_life_insurance_broker: insuranceBroker,
    }

    return new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then((response) => {
          console.log('API convert policy ::', response)
          if (response.status === 200) {
            if (response.data.isSuccess) {
              resolve(response.data)
            } else {
              reject(response.data.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Export Excel
   * @param {Object} credentials - The export data
   * @param {string} credentials.start_date - Start date
   * @param {string} credentials.end_date - End date
   * @returns {Promise}
   */
  exportExcel(context, credentials) {
    console.log('exportExcel params ::', credentials)
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_QUICKQUOTE_SME_EXPORT_EXCEL, credentials, {
          responseType: 'blob',
        })
        .then((res) => resolve(res))
        .catch((err) => {
          if (err.response?.data instanceof Blob) {
            err.response.data.text().then((text) => console.error('API Error:', text))
          }
          reject(err)
        })
    })
  },

  /**
   * Get Payment Status
   * @param {Object} credentials - The payment status data
   * @param {string} credentials.invoiceNo - Invoice number
   * @returns {Promise}
   */
  getPaymentStatus(context, credentials) {
    console.log('getPaymentStatus params ::', credentials)

    const url = process.env.VUE_APP_QUICKQUOTE_GET_PAYMENT_STATUS.replace(':invoice_no', credentials.invoiceNo)

    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((response) => {
          console.log('API get payment status ::', response)
          if (response.status === 200) {
            if (response.data.isSuccess && response.data.paymentStatus) {
              resolve(response.data)
            } else {
              reject(response.data.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          reject(error)
        })
    })
  },

  /**
   * Report OPUS (Quickdraft endpoint)
   * @param {Object} credential - Report params
   * @param {boolean} credential.all
   * @param {boolean} credential.wht
   * @param {boolean} credential.other
   * @param {string} credential.startDate
   * @param {string} credential.endDate
   * @returns {Promise}
   */
  reportOpus(context, credential) {
    return new Promise((resolve, reject) => {
      console.log('report opus params ::', credential)
      const params = {}
      let paths = ''
      if (credential.startDate && credential.endDate) {
        params.all = credential.all
        params.wht = credential.wht
        params.other = credential.other
        params.startDate = credential.startDate
        params.endDate = credential.endDate
        paths += params.all ? '?all=' + params.all : '?all=false'
        paths += params.wht ? '&wht=' + params.wht : ''
        paths += params.other ? '&other=' + params.other : ''
        paths += params.startDate ? '&startDate=' + params.startDate : ''
        paths += params.endDate ? '&endDate=' + params.endDate : ''
      } else {
        params.wht = credential.wht
        paths = params.wht ? '?wht=' + params.wht : ''
      }
      console.log('report opus paths ::', paths)
      console.log('report opus params ::', params)

      axios
        .get(process.env.VUE_APP_QUICKDRAFT_REPORT_OPUS + paths)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
